import React, { Component } from "react";
import { MqttContext } from "../../Contexts/MqttProvider.js";
import {
  apiSubmissionFormUpdate,
  apiSubmissionFormList,
  // apiCountJobList,
  apiVpsOptionAvailable,
  apiActionAutoLogin,
  apiActionChangeLot,
  apiActionAutoLogout,
  apiActionAutoReActive,
  // apiActionAutoClose,
  apiAccountAutoOption,
  apiAutoActionSubmission,
  apiAutoActionSubmissionApprove,
  apiAutoActionSubmissionUpdate,
  apiMasterSlaveOption,
  apiUserOption,
  apiAgentOption,
  // apiAutoReject,
  apiSubmissionAccountAddAgent,
  apiCheckEmailAffiliation,
  apiEmailBrokerUser,
} from "../../Service/api";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactTable from "react-table";
import "react-table/react-table.css";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Dialog,
  AppBar,
  Toolbar,
  DialogActions,
  DialogContent,
  IconButton,
  DialogContentText,
  Stack,
  Alert,
  DialogTitle,
  Slide,
  CircularProgress,
  TextField,
} from "@mui/material";
import {
  Refresh,
  Close,
  Cancel,
  Check,
  CheckBox,
  Save,
  Assessment,
  Publish,
  AddBox,
  VisibilityOff,
  Visibility,
} from "@mui/icons-material";
import { Input, InputGroup, InputGroupText, InputGroupAddon } from "reactstrap";
import ModalLoading from "../../Components/Modal/ModalLoading.js";
import dayjs from "dayjs";
import Select, { components } from "react-select";

const stylesListComent = {
  inline: {
    display: "inline",
  },
};

const stylesDialog = {
  appBar: {
    position: "relative",
    backgroundColor: "#03101e",
  },
  title: {
    marginLeft: 0,
    flex: 1,
    fontSize: 16,
  },
};

const stylesListDialog = {
  inline: {
    display: "inline",
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const isIOS = () => {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod",
    ].includes(navigator.platform) ||
    // iPad on iOS 13+ reports as Mac
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
};

const CustomOption = (props) => {
  const color = props.data.flag_auto === "1" ? "green" : "blue";

  return (
    <components.Option {...props}>
      <div style={{ color, display: "flex", alignItems: "center" }}>
        {props.data.label}
      </div>
    </components.Option>
  );
};

const defaultFilterMethod = (filter, row) => {
  const cellValue = String(row[filter.id]).toLowerCase();
  return cellValue.includes(filter.value.toLowerCase());
};

class SubmissionFormListPage extends Component {
  constructor(props) {
    // console.log("props: ", props);
    super(props);
    this.mqttRef = React.createRef();
    this.setAccountNumber = React.createRef();
    this.setEmail = React.createRef();
    this.setAlias = React.createRef();
    this.setPassword = React.createRef();
    this.setLot = React.createRef();
    this.setCapital = React.createRef();
    this.setNote = React.createRef();
    this.setCategory = React.createRef();
    this.setCategory.current = {
      value: "OPENING ACCOUNT",
      label: "OPENING ACCOUNT",
    };
    this.setAgent = React.createRef();
    this.setMaster = React.createRef();
    this.setAccountType = React.createRef();
    this.setUser = React.createRef();

    this.reactTable = React.createRef();
    this.state = {
      tableData: [],
      tableDisplay: [],
      filter: "",
      setOpenEdit: false,
      setOpenAddNew: false,
      openSuccess: false,
      openSuccessText: "",
      openValidation: false,
      titleValidation: "",
      titleBody: "",
      openAlertApprove: false,
      openAlertReject: false,
      itemSelectedRow: {},
      selectAll: false,
      checked: [],
      selectRowData: [],
      openSelectedRow: false,
      dataTelegramAccountShow: [],
      left: [],
      right: [],
      checked_transfer: [],
      available: [],
      showLoadingReject: false,
      showLoadingApprove: false,
      showLoadingRejectAll: false,
      showLoadingSubmit: false,
      showLoading: false,
      dataDetail: "",
      submitLoading: false,
      note: "",
      loginInfo: "",
      showPassword: false,
      jobItemDetail: null,
      setOpenDetail: false,
      optionVps: [],
      vpsSelected: null,
      categoryOption: [
        { value: "OPENING ACCOUNT", label: "OPENING ACCOUNT" },
        { value: "CHANGE LOT", label: "CHANGE LOT" },
        { value: "SUSPEND", label: "SUSPEND" },
        { value: "ACTIVE", label: "ACTIVE" },
      ],
      accountAutoOption: [],
      optionAgent: [],
      optionMasterSlave: [],
      optionAccountType: [
        { label: "EURUSDc", value: "EURUSDc" },
        { label: "XAUUSDc", value: "XAUUSDc" },
        // { label: "HR SPDR XAU", value: "HR_EU" },
        { label: "Low Risk XAU", value: "LR_XAU" },
        // { label: "SPDR XAU", value: "SPDR_XAU" },
        { label: "EURUSD 2.0", value: "EURUSD_2" },
        { label: "EURUSD 3.0", value: "EURUSD_3" },
        { label: "JKW XAU", value: "JKW_XAU" },
        { label: "JKW 3.0 XAU", value: "JKW_3_XAU" },
        { label: "JKW 3.0 SLOW", value: "JKW_3_SLOW_XAU" },
        // { label: "JKW24K", value: "JKW24K" },
        { label: "BlueStar", value: "BlueStar" },
        { label: "BlueStar5", value: "BlueStar5" },
        { label: "BlueStar15", value: "BlueStar15" },
        // { label: "JKWRJWFast", value: "JKWRJWFAST" },
        { label: "BlueStarR", value: "BlueStarR" },
        { label: "BlueStar5R", value: "BlueStar5R" },
        { label: "BlueStar15R", value: "BlueStar15R" },
        { label: "RJW88Slow", value: "RJW88Slow" },
        { label: "RJW88Fast", value: "RJW88Fast" },
        { label: "JKW88", value: "JKW88" },
        // { label: "CTC", value: "CTC" },
        { label: "SM", value: "SM" },
        { label: "FTG", value: "FTG" },
        { label: "OSOK", value: "OSOK" },
        { label: "BTC", value: "BTC" },
        { label: "BTCMu", value: "BTCMu" },
        { label: "GBPJPY", value: "GBPJPY" },
      ],
      accountTypeSelected: null,
      optionUser: [],
      secretKey:
        "e69902f8ca7bf37cb776f323384f502205cb907e8935c118faf6803e239402d6",
      agentSelected: null,
      topicSubscribeBalancer: "",
      topicSubscribeClientGUI: "",
      checkVps: null,
      messagesBalancerServer: "",
      messagesClientGUI: null,
      openModalLoading: false,
      clientGUIFinal: false,
      isLoginSuccessful: false,
      lotError: null,
      loadingAffiliation: false,
      isAffiliated: null,
      optionAccount: [],
      selectedAccount: null,
      selectedAccountType: null,
      selectedEmail: null,
      selectedAgent: null,
      selectedUser: null,
      optionEmailBrokerUser: [],
      emailBrokerDataRecords: [],
      isCustomEmail: false,
      originalDataAccounts: [],
    };

    this.isSubscribed = false;

    this.isFinished = false;
    this.isMessagePublished = false;
    this._isMounted = false;
    this.closeModalTimeoutId = null;
    this.updateMsgTimeoutId = null;

    this.tableColumns = [
      {
        Header: "Time",
        id: "timeColumn",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: (row) => row.updated_at || row.created_at,
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: ({ row }) => {
          // console.log("row: ", row);
          const timestamp =
            (row && row.timeColumn) || (row && row.timeColumn) || "N/A";

          return (
            <Typography
              component="span"
              variant="body2"
              style={{
                display: "inline-block",
              }}
            >
              {timestamp !== "N/A"
                ? dayjs(timestamp).format("DD/MM/YYYY HH:mm:ss")
                : "N/A"}
            </Typography>
          );
        },
        width: 180,
      },
      {
        Header: "Category",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "status",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.status}
          </Typography>
        ),
      },
      {
        Header: "Account",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "account_id",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.account_id}
          </Typography>
        ),
      },
      {
        Header: "Note",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "note",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.note}
          </Typography>
        ),
      },
      {
        Header: "Client",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "client",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.client}
          </Typography>
        ),
      },
      {
        Header: "Action",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 220,
        Cell: (e) => (
          <div>
            <Button
              variant="contained"
              size="small"
              style={{
                backgroundColor: "#3f51b5",
              }}
              startIcon={<Assessment />}
              onClick={() => this.doRowDetail(e.original)}
            >
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Detail
              </Typography>
            </Button>
          </div>
        ),
      },
    ];
    this.noteInputRef = React.createRef();
  }

  static contextType = MqttContext;

  deepEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  resetFlags = () => {
    this.isFinished = false;
    this.isMessagePublished = false;
  };

  componentDidMount() {
    let loginInfo = localStorage.getItem("loginInfo");
    loginInfo = JSON.parse(loginInfo);
    this._isMounted = true;
    this.setState({
      messagesBalancerServer: "",
      messagesClientGUI: null,
      topicSubscribeBalancer: "",
      topicSubscribeClientGUI: "",
      loginInfo: loginInfo,
    });
    this.doLoadData();
    this.doLoadOption();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const { messagesBalancerServer, messagesClientGUI } = this.context || {};

    if (this.isFinished) return;

    if (messagesBalancerServer && !this.state.messagesBalancerServer) {
      // console.log("messagesBalancerServer: ", messagesBalancerServer);
      if (this._isMounted) {
        this.setState({ messagesBalancerServer }, () => {
          this.updateMsgTimeoutId = setTimeout(() => {
            if (!this.isMessagePublished && this._isMounted) {
              this.updateMessage();
              this.isMessagePublished = true;
            }
          }, 3000);
        });
      }
    }

    if (messagesClientGUI) {
      const currentMsg = this.state.messagesClientGUI;
      if (
        messagesClientGUI.status !== "Success" &&
        messagesClientGUI.status !== "Failed"
      ) {
        if (!currentMsg || !this.deepEqual(currentMsg, messagesClientGUI)) {
          // console.log(
          //   "messagesClientGUI update (non-terminal): ",
          //   messagesClientGUI
          // );
          let formattedMessage = messagesClientGUI.message;
          if (formattedMessage && typeof formattedMessage === "string") {
            formattedMessage = formattedMessage
              .replace(/-------------------------\n?/g, "")
              .trim();
          }
          const isLoginSuccessful =
            formattedMessage.includes("Login Successful");
          if (this._isMounted) {
            this.setState({
              messagesClientGUI: {
                ...messagesClientGUI,
                message: formattedMessage,
              },
              isLoginSuccessful,
            });
          }
        }
      } else {
        if (!currentMsg || !this.deepEqual(currentMsg, messagesClientGUI)) {
          // console.log("messagesClientGUI update (final): ", messagesClientGUI);
          let formattedMessage = messagesClientGUI.message;
          if (formattedMessage && typeof formattedMessage === "string") {
            formattedMessage = formattedMessage
              .replace(/-------------------------\n?/g, "")
              .trim();
          }
          const isLoginSuccessful =
            formattedMessage.includes("Login Successful");
          if (this._isMounted) {
            this.setState(
              {
                messagesClientGUI: {
                  ...messagesClientGUI,
                  message: formattedMessage,
                },
                isLoginSuccessful,
              },
              () => {
                if (
                  this.state.messagesClientGUI &&
                  (this.state.messagesClientGUI.status === "Success" ||
                    this.state.messagesClientGUI.status === "Failed")
                ) {
                  this.closeModalTimeoutId = setTimeout(() => {
                    if (this._isMounted && this.state.messagesClientGUI) {
                      this.setState({ openModalLoading: false }, () => {
                        this.finalizeMqttSubscriptions();
                      });
                    }
                  }, 5000);
                }
                this.isFinished = true;
              },
            );
          }
        }
      }
    }
  }

  updateMessage = () => {
    const { messagesBalancerServer, loginInfo } = this.state;
    if (!messagesBalancerServer) return;
    const { publishMessage, subscribeToTopic, isConnected } = this.context;
    const account_number =
      (this.setAccountNumber.current && this.setAccountNumber.current.value) ||
      "";
    const password =
      (this.setPassword.current && this.setPassword.current.value) || "";

    const payload = {
      action: "checkPassword",
      accountNumber: account_number,
      unencryptedPassword: password,
      clientId: loginInfo.phoneno,
      referenceId: account_number,
      priority: 3,
    };

    const topicPublish = `Server-GUI/${messagesBalancerServer}/action`;
    publishMessage(topicPublish, payload);

    const topicSubscribeClientGUI = `Client-GUI/${loginInfo.phoneno}/response`;
    if (isConnected) {
      subscribeToTopic(topicSubscribeClientGUI);
      if (this._isMounted) {
        this.setState({ topicSubscribeClientGUI });
      }
    }
  };

  finalizeMqttSubscriptions = () => {
    const { unsubscribeFromTopic, resetMessages } = this.context;
    if (this.state.topicSubscribeClientGUI) {
      unsubscribeFromTopic(this.state.topicSubscribeClientGUI);
    }
    if (this.state.topicSubscribeBalancer) {
      unsubscribeFromTopic(this.state.topicSubscribeBalancer);
    }
    if (this._isMounted) {
      this.setState({
        topicSubscribeBalancer: "",
        topicSubscribeClientGUI: "",
        messagesBalancerServer: "",
        messagesClientGUI: null,
      });
    }
    resetMessages();
    this.isMessagePublished = false;
  };

  handleCheckActivation = () => {
    this.resetFlags();
    const { isConnected, subscribeToTopic } = this.context;
    const category =
      (this.setCategory.current && this.setCategory.current.value) || "";
    const account_number =
      (this.setAccountNumber.current && this.setAccountNumber.current.value) ||
      "";
    const password =
      (this.setPassword.current && this.setPassword.current.value) || "";

    // const account_number_server =
    //   (this.setAccountNumber.current && this.setAccountNumber.current.label) ||
    //   "";

    const platform_server =
      (this.setAccountNumber.current &&
        (this.setAccountNumber.current.server ||
          this.setAccountNumber.current.label)) ||
      "";

    const serverName = (platform_server || "").toLowerCase();

    // console.log("account_number_server: ", account_number_server);
    // console.log("serverName: ", serverName);

    const isMT5 = serverName.includes("mt5");

    console.log("isMT5: ", isMT5);

    if (!account_number) {
      this.setState({
        openValidation: true,
        titleValidation: "Account number Required",
        titleBody: "Please enter your account number.",
      });
    } else if (category === "ACTIVE" && password === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Password Required",
        titleBody: "Please enter your password.",
      });
    } else if (category === "OPENING ACCOUNT" && password === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Password Required",
        titleBody: "Please enter your password.",
      });
    } else {
      // const topicSubscribeBalancer = `Balancer/MT4/Server-GUI/3`;
      const topicSubscribeBalancer = isMT5
        ? `Balancer/MT5/Server-GUI/3`
        : `Balancer/MT4/Server-GUI/3`;
      if (isConnected) {
        // console.log("Subscribing to topic: ", topicSubscribeBalancer);
        this.setState({ openModalLoading: true });
        subscribeToTopic(topicSubscribeBalancer);
        this.setState({ topicSubscribeBalancer });
      } else {
        console.log("MQTT is not connected.");
      }
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
    if (this.closeModalTimeoutId) {
      clearTimeout(this.closeModalTimeoutId);
    }
    if (this.updateMsgTimeoutId) {
      clearTimeout(this.updateMsgTimeoutId);
    }
    const { unsubscribeFromTopic } = this.context;
    if (this.state.topicSubscribeBalancer) {
      unsubscribeFromTopic(this.state.topicSubscribeBalancer);
    }
    if (this.state.topicSubscribeClientGUI) {
      unsubscribeFromTopic(this.state.topicSubscribeClientGUI);
    }
    this.setState({
      messagesBalancerServer: "",
      messagesClientGUI: null,
      topicSubscribeBalancer: "",
      topicSubscribeClientGUI: "",
    });
  }

  doLoadData = () => {
    this.props.doLoading();
    apiSubmissionFormList()
      .then((res) => {
        this.props.doLoading();
        let data = res.data;
        if (data.code === 200) {
          if (data.records.length > 0) {
            const temp = data.records;

            this.setState({
              tableData: temp,
            });
          } else {
            this.setState({
              tableData: [],
            });
          }
        } else {
          this.setState({
            tableData: [],
          });
        }
      })
      .catch((err) => {
        this.props.doLoading();
        console.log(err);
      });

    apiEmailBrokerUser()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            const dataRecords = data.records;

            const optionEmailBrokerUser = [
              { value: "custom_email", label: "Input New Email" },
              ...dataRecords.map((obj) => ({
                value: obj.email,
                label: obj.email,
              })),
            ];

            this.setState({
              optionEmailBrokerUser,
              emailBrokerDataRecords: dataRecords,
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  doLoadOption = () => {
    apiVpsOptionAvailable()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          // console.log("option vps: ", data.records);
          const optionVps = data.records.map((vps) => {
            return {
              value: vps.value,
              label: `${vps.label} (${
                vps.flag_auto === "1" ? "Auto" : "Manual"
              }) - ${vps.available} available`,
              vps_name: vps.vps_name,
              flag_auto: vps.flag_auto,
              available: vps.available,
            };
          });

          this.setState({
            optionVps: optionVps,
          });
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });

    apiAccountAutoOption()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          if (data.records.length > 0) {
            this.setState({
              accountAutoOption: data.records,
            });
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });

    apiAgentOption()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          this.setState({
            optionAgent: data.records,
          });
        }
      })
      .catch((err) => {
        console.error("err: ", err);
      });

    apiMasterSlaveOption()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          this.setState({
            optionMasterSlave: data.records,
          });
        }
      })
      .catch((err) => {
        console.error("err: ", err);
      });

    apiUserOption()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          this.setState({
            optionUser: data.records,
          });
        }
      })
      .catch((err) => {
        console.error("err: ", err);
      });
  };

  doApproveItem = (item) => {
    // console.log("item : ", item);
    this.props.doLoading();
    this.setState({ showLoadingApprove: true });

    const vps = this.state.vpsSelected;

    // console.log("vps: ", vps);

    let params = {
      account_id: item.account_id,
      alias: item.alias,
      password: item.password,
      lot: item.lot,
      capital: item.capital,
      ticket_id: item.ticket_id,
      category: item.status,
      key: item.key,
      executor: this.state.loginInfo.name,
      status: 4,
      note: this.state.note,
    };

    const agent =
      this.setAgent.current && Array.isArray(this.setAgent.current)
        ? this.setAgent.current
        : this.setAgent.current
          ? [this.setAgent.current]
          : [];

    const master =
      this.setMaster.current && Array.isArray(this.setMaster.current)
        ? this.setMaster.current
        : this.setMaster.current
          ? [this.setMaster.current]
          : [];

    const vpsArr = vps && Array.isArray(vps) ? vps : vps ? [vps] : [];

    let payloadAddAgent = {
      account_number: item.account_id,
      agent: agent,
      master: master,
      vps: vps !== null ? (vps.flag_auto === "1" ? [] : vpsArr) : [],
    };

    // console.log("payloadAddAgent: ", payloadAddAgent);

    if (item.client !== "3DVAM") {
      apiSubmissionFormUpdate(params)
        .then((res) => {
          this.setState({ showLoadingApprove: false });
          this.props.doLoading();
          let data = res.data;
          if (data.status === "OK") {
            this.setState({
              openSuccess: true,
              openSuccessText: "Data successfully approve",
              openAlertApprove: false,
              openAlertReject: false,
              setOpenDetail: false,
            });
          }
        })
        .catch((err) => {
          this.setState({ showLoadingApprove: false });
          this.props.doLoading();
          console.log(err);
        });

      if (item.status === "OPENING ACCOUNT") {
        apiSubmissionAccountAddAgent(payloadAddAgent)
          .then((res) => {
            const data = res.data;
            console.info(data);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    } else {
      apiAutoActionSubmissionUpdate(params)
        .then((res) => {
          this.setState({ showLoadingApprove: false });
          this.props.doLoading();
          let data = res.data;
          if (data.status === "OK") {
            this.setState({
              openSuccess: true,
              openSuccessText: "Data successfully approve",
              openAlertApprove: false,
              openAlertReject: false,
              setOpenDetail: false,
            });
          }
        })
        .catch((err) => {
          this.setState({ showLoadingApprove: false });
          this.props.doLoading();
          console.log(err);
        });
    }

    if (vps !== null) {
      //flag Auto
      if (vps.flag_auto === "1") {
        // console.log("start vps automation");
        if (item.status === "OPENING ACCOUNT") {
          const actionStatus = item.status === "OPENING ACCOUNT" ? "login" : "";
          let paramsAuto = {
            client_id: this.state.loginInfo.phoneno,
            vps: vps.vps_name,
            action: actionStatus,
            vps_id: vps.value,
            account_number: item.account_id,
            alias: item.alias,
            password: item.password,
            password_master: item.password_master,
            password_investor: item.password_investor,
            lot: item.lot,
          };

          // console.log("paramsAuto: ", paramsAuto);
          apiActionAutoLogin(paramsAuto)
            .then((res) => {
              const data = res.data;
              if (data.status === "success") {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              } else {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({
                jobItemDetail: null,
                vpsSelected: null,
              });
            });
        } else if (item.status === "CHANGE LOT") {
          const actionStatus = item.status === "CHANGE LOT" ? "changeLot" : "";
          let paramsAuto = {
            client_id: this.state.loginInfo.phoneno,
            vps: vps.vps_name,
            action: actionStatus,
            vps_id: vps.value,
            account_number: item.account_id,
            alias: item.alias,
            lot: item.lot,
          };

          // console.log("paramsAuto: ", paramsAuto);
          apiActionChangeLot(paramsAuto)
            .then((res) => {
              const data = res.data;
              if (data.status === "success") {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              } else {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({
                jobItemDetail: null,
                vpsSelected: null,
              });
            });
        } else if (item.status === "ACTIVE") {
          const actionStatus = "active";
          let paramsAuto = {
            client_id: this.state.loginInfo.phoneno,
            vps: vps.vps_name,
            action: actionStatus,
            vps_id: vps.value,
            account_number: item.account_id,
            lot: item.lot,
            password: item.password,
            password_master: item.password_master,
            password_investor: item.password_investor,
          };

          // console.log("paramsAuto: ", paramsAuto);
          apiActionAutoReActive(paramsAuto)
            .then((res) => {
              const data = res.data;
              if (data.status === "success") {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              } else {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({
                jobItemDetail: null,
                vpsSelected: null,
              });
            });
        } else if (item.status === "INACTIVE") {
          const actionStatus = "logout";
          let paramsAuto = {
            client_id: this.state.loginInfo.phoneno,
            vps: vps.vps_name,
            action: actionStatus,
            vps_id: vps.value,
            account_number: item.account_id,
          };

          // console.log("paramsAuto: ", paramsAuto);
          apiActionAutoLogout(paramsAuto)
            .then((res) => {
              const data = res.data;
              if (data.status === "success") {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              } else {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({
                jobItemDetail: null,
                vpsSelected: null,
              });
            });
        } else if (item.status === "SUSPENDED") {
          const actionStatus = "logout";
          let paramsAuto = {
            client_id: this.state.loginInfo.phoneno,
            vps: vps.vps_name,
            action: actionStatus,
            vps_id: vps.value,
            account_number: item.account_id,
          };

          // console.log("paramsAuto: ", paramsAuto);
          apiActionAutoLogout(paramsAuto)
            .then((res) => {
              const data = res.data;
              if (data.status === "success") {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              } else {
                this.setState({
                  jobItemDetail: null,
                  vpsSelected: null,
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.setState({
                jobItemDetail: null,
                vpsSelected: null,
              });
            });
        }
      }
    }
  };

  doRejectItem = (item) => {
    // console.log("item reject: ", item);
    this.props.doLoading();
    this.setState({ showLoadingReject: true });
    let params = {
      account_id: item.account_id,
      alias: item.alias,
      password: item.password,
      lot: item.lot,
      capital: item.capital,
      ticket_id: item.ticket_id,
      category: item.status,
      key: item.key,
      executor: this.state.loginInfo.name,
      status: 5,
      note: this.state.note,
    };

    if (item.client !== "3DVAM") {
      // console.log("params reject: ", params);
      apiSubmissionFormUpdate(params)
        .then((res) => {
          this.setState({ showLoadingReject: false });
          this.props.doLoading();
          let data = res.data;
          if (data.status === "OK") {
            this.setState({
              openSuccess: true,
              openSuccessText: "The ticket has been rejected successfully.",
              openAlertApprove: false,
              openAlertReject: false,
              setOpenDetail: false,
            });
          }
        })
        .catch((err) => {
          this.setState({ showLoadingReject: false });
          this.props.doLoading();
          console.log(err);
        });
    } else {
      apiAutoActionSubmissionUpdate(params)
        .then((res) => {
          this.setState({ showLoadingReject: false });
          this.props.doLoading();
          let data = res.data;
          if (data.status === "OK") {
            this.setState({
              openSuccess: true,
              openSuccessText: "The ticket has been rejected successfully.",
              openAlertApprove: false,
              openAlertReject: false,
              setOpenDetail: false,
            });
          }
        })
        .catch((err) => {
          this.setState({ showLoadingReject: false });
          this.props.doLoading();
          console.log(err);
        });
    }
  };

  doRowApproveInfo = (item) => {
    this.setState({
      openAlertApprove: true,
      itemSelectedRow: item,
    });
  };

  doRowRejectInfo = (item) => {
    this.setState({
      openAlertReject: true,
      itemSelectedRow: item,
    });
  };

  handleCloseItemInfo = () => {
    this.setState({
      openAlertApprove: false,
      openAlertReject: false,
      itemSelectedRow: {},
      selectRowData: [],
      note: "",
    });
  };

  doRowDetail = (item) => {
    // console.log("item detail: ", item);
    const vpsData = this.state.optionVps;
    const agentData = this.state.optionAgent;

    // console.log("agentData: ", agentData);
    const agentSelected = agentData.filter(
      (agent) => agent.label.toLowerCase() === item.client.toLowerCase(),
    );

    // console.info("agentSelected: ", agentSelected);

    this.setAgent.current = agentSelected.length > 0 ? agentSelected[0] : null;
    this.forceUpdate();

    this.setState({
      selectedAgent: agentSelected.length > 0 ? agentSelected[0] : null,
    });

    const vpsSelected = vpsData.filter((data) =>
      item.vps.some((v) => v.vps_id === data.value),
    );
    // console.info("vpsSelected: ", vpsSelected);
    this.setState({
      jobItemDetail: item,
      setOpenDetail: true,
      vpsSelected: vpsSelected.length > 0 ? vpsSelected[0] : null,
    });
  };

  handleCloseOpenDetail = () => {
    this.setState({
      jobItemDetail: null,
      setOpenDetail: false,
      openAlertApprove: false,
      openAlertReject: false,
      vpsSelected: null,
    });
  };

  doProcessedApproved = () => {
    this.setState({
      openAlertApprove: true,
    });
  };

  doProcessedReject = () => {
    this.setState({
      openAlertReject: true,
    });
  };

  handleChangeVps = (vps) => {
    this.setState({
      vpsSelected: vps,
    });
  };

  renderOpenDetail = () => {
    if (this.state.jobItemDetail !== null) {
      const {
        openAlertApprove,
        openAlertReject,
        jobItemDetail,
        optionVps,
        vpsSelected,
      } = this.state;
      const item = jobItemDetail;

      let vpsOptionAuto = [];
      let vpsOptionManual = [];

      if (item.client === "3DVAM") {
        if (item.status === "OPENING ACCOUNT" || item.status === "ACTIVE") {
          vpsOptionAuto = optionVps.filter(
            (obj) => obj.available !== 0 && obj.flag_auto === "1",
          );
        } else {
          const tempOption = optionVps.filter((obj) => obj.flag_auto === "1");
          vpsOptionAuto = tempOption.map((item) => {
            const labelParts = item.label.split(" - ");
            // console.log("labelParts: ", labelParts);
            return {
              ...item,
              label: labelParts[0],
            };
          });
        }

        // const vpsSelected = vpsOptionAuto.filter((data) =>
        //   item.vps.some((v) => v.vps_id === data.value)
        // );
        // console.info("vpsSelected: ", vpsSelected);
        // this.setState({
        //   vpsSelected: vpsSelected.length > 0 ? vpsSelected[0] : null,
        // });
      } else {
        if (item.status === "OPENING ACCOUNT" || item.status === "ACTIVE") {
          // vpsOptionManual = optionVps.filter((obj) => obj.available !== 0);

          if (
            item.account_type === "XAUUSDc" ||
            item.account_type === "XAUUSD"
          ) {
            vpsOptionManual = optionVps.filter(
              (obj) =>
                obj.vps_name.toUpperCase().includes("GOLD") &&
                obj.available !== 0,
            );
          } else if (
            item.account_type === "EURUSD" ||
            item.account_type === "EURUSDc" ||
            item.account_type === "HR_EU"
          ) {
            vpsOptionManual = optionVps.filter(
              (obj) =>
                !obj.vps_name.toUpperCase().includes("GOLD") &&
                obj.available !== 0,
            );
          } else {
            vpsOptionManual = optionVps.filter((obj) => obj.available !== 0);
          }
        } else {
          vpsOptionManual = optionVps.map((item) => {
            const labelParts = item.label.split(" - ");
            return {
              ...item,
              label: labelParts[0],
            };
          });
        }
      }

      // console.log("vpsOptionManual: ", vpsOptionManual);

      // console.log("optionVps: ", optionVps);

      const title =
        openAlertApprove === true
          ? `Approve Account: ${item.account_id}`
          : openAlertReject === true
            ? `Reject Account: ${item.account_id}`
            : "Job List Account Details";
      return (
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={this.state.setOpenDetail}
          fullWidth={true}
          maxWidth="md"
        >
          <AppBar style={stylesDialog.appBar}>
            <Toolbar>
              <Typography variant="h5" style={stylesDialog.title}>
                {title}
              </Typography>
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => this.handleCloseOpenDetail()}
                aria-label="close"
              >
                <Close />
              </IconButton>
            </Toolbar>
          </AppBar>
          {openAlertApprove === true ? (
            <>
              <DialogContent dividers>
                <Box
                  sx={{ flexGrow: 1 }}
                  style={{ marginBottom: 60, marginTop: 20 }}
                >
                  <Grid container spacing={2}>
                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        VPS
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Select
                        classNamePrefix="select"
                        placeholder="Select a vps"
                        value={vpsSelected}
                        onChange={this.handleChangeVps}
                        options={
                          item.client === "3DVAM"
                            ? vpsOptionAuto
                            : vpsOptionManual
                        }
                        components={{ Option: CustomOption }}
                        styles={{
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                        menuPosition={"fixed"}
                      />
                    </Grid>

                    {item.client === "3DVAM" ? null : item.client !== "3DVAM" &&
                      (item.status === "OPENING ACCOUNT" ||
                        item.status === "ACTIVE") ? (
                      <>
                        <Grid item lg={2} md={3} sm={3} xs={12}>
                          <Typography
                            component="span"
                            variant="subtitle1"
                            style={{
                              float: "left",
                              marginTop: 6,
                              textTransform: "capitalize",
                            }}
                          >
                            Agent
                          </Typography>
                        </Grid>
                        <Grid item lg={10} md={9} sm={9} xs={12}>
                          <Select
                            classNamePrefix="select"
                            placeholder="Select a agent"
                            isClearable={true}
                            value={this.setAgent.current}
                            onChange={this.handleChangeAgent}
                            options={this.state.optionAgent}
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition={"fixed"}
                            menuPlacement="top"
                          />
                        </Grid>
                      </>
                    ) : null}

                    {item.client === "3DVAM" ? null : item.client !== "3DVAM" &&
                      (item.status === "OPENING ACCOUNT" ||
                        item.status === "ACTIVE") ? (
                      <>
                        <Grid item lg={2} md={3} sm={3} xs={12}>
                          <Typography
                            component="span"
                            variant="subtitle1"
                            style={{
                              float: "left",
                              marginTop: 6,
                              textTransform: "capitalize",
                            }}
                          >
                            Master
                          </Typography>
                        </Grid>
                        <Grid item lg={10} md={9} sm={9} xs={12}>
                          <Select
                            classNamePrefix="select"
                            placeholder="Select a master"
                            isClearable={true}
                            onChange={this.handleChangeMaster}
                            options={this.state.optionMasterSlave}
                            styles={{
                              menuPortal: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                            menuPortalTarget={document.body}
                            menuPosition={"fixed"}
                            menuPlacement="top"
                          />
                        </Grid>
                      </>
                    ) : null}

                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Note
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <TextField
                        id="note"
                        type="text"
                        fullWidth
                        value={this.state.note}
                        inputRef={this.noteInputRef}
                        onChange={this.handleNoteChange}
                        variant="outlined"
                        label={<div style={{ height: 0 }} />}
                        InputProps={{
                          notched: false,
                        }}
                        sx={{
                          "& fieldset": {
                            top: 0,
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  disabled={this.state.showLoadingApprove}
                  variant="contained"
                  size="large"
                  style={{
                    backgroundColor: "#008b02",
                  }}
                  startIcon={<Publish />}
                  onClick={() => this.doApproveItem(item)}
                >
                  {this.state.showLoadingApprove === true ? (
                    <CircularProgress style={{ color: "#fff" }} size={24} />
                  ) : (
                    <Typography
                      variant="button"
                      style={{
                        color: "#fff",
                        textTransform: "capitalize",
                      }}
                    >
                      Submit Approved
                    </Typography>
                  )}
                </Button>
                &nbsp;&nbsp;
                <Button
                  disabled={this.state.showLoadingApprove}
                  variant="contained"
                  size="large"
                  style={{
                    backgroundColor: "#d0021b",
                  }}
                  startIcon={<Cancel />}
                  onClick={() =>
                    this.setState({
                      openAlertApprove: false,
                      openAlertReject: false,
                    })
                  }
                >
                  <Typography
                    variant="button"
                    style={{
                      color: "#fff",
                      textTransform: "capitalize",
                    }}
                  >
                    Cancel
                  </Typography>
                </Button>
              </DialogActions>
            </>
          ) : openAlertReject === true ? (
            <>
              <>
                <DialogContent dividers>
                  <Box
                    sx={{ flexGrow: 1 }}
                    style={{ marginBottom: 60, marginTop: 20 }}
                  >
                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          autoFocus
                          margin="dense"
                          id="note"
                          label="Note"
                          type="text"
                          fullWidth
                          value={this.state.note}
                          inputRef={this.noteInputRef}
                          onChange={this.handleNoteChange}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button
                    disabled={this.state.showLoadingReject}
                    variant="contained"
                    size="large"
                    style={{
                      backgroundColor: "#008b02",
                    }}
                    startIcon={<Publish />}
                    onClick={() => this.doRejectItem(item)}
                  >
                    {this.state.showLoadingReject === true ? (
                      <CircularProgress style={{ color: "#fff" }} size={24} />
                    ) : (
                      <Typography
                        variant="button"
                        style={{
                          color: "#fff",
                          textTransform: "capitalize",
                        }}
                      >
                        Submit Rejected
                      </Typography>
                    )}
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    disabled={this.state.showLoadingReject}
                    variant="contained"
                    size="large"
                    style={{
                      backgroundColor: "#d0021b",
                    }}
                    startIcon={<Cancel />}
                    onClick={() =>
                      this.setState({
                        openAlertApprove: false,
                        openAlertReject: false,
                      })
                    }
                  >
                    <Typography
                      variant="button"
                      style={{
                        color: "#fff",
                        textTransform: "capitalize",
                      }}
                    >
                      Cancel
                    </Typography>
                  </Button>
                </DialogActions>
              </>
            </>
          ) : (
            <>
              <DialogContent dividers>
                <Box
                  sx={{ flexGrow: 1 }}
                  style={{ marginBottom: 60, marginTop: 20 }}
                >
                  <Grid container spacing={2}>
                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Time
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Input
                        autoComplete="off"
                        type="text"
                        name="time"
                        id="time"
                        value={dayjs(
                          item.updated_at !== null
                            ? item.updated_at
                            : item.created_at,
                        ).format("DD/MM/YYYY HH:mm:ss")}
                      />
                    </Grid>

                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Category
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Input
                        autoComplete="off"
                        type="text"
                        name="category"
                        id="category"
                        value={item.status}
                      />
                    </Grid>

                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Ticket ID
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Input
                        autoComplete="off"
                        type="text"
                        name="ticket_id"
                        id="ticket_id"
                        value={item.ticket_id}
                      />
                    </Grid>

                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Account
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Input
                        autoComplete="off"
                        type="text"
                        name="account_id"
                        id="account_id"
                        value={item.account_id}
                      />
                    </Grid>

                    {item.status !== "OPENING ACCOUNT" ? null : (
                      <>
                        <Grid item lg={2} md={3} sm={3} xs={12}>
                          <Typography
                            component="span"
                            variant="subtitle1"
                            style={{
                              float: "left",
                              marginTop: 6,
                              textTransform: "capitalize",
                            }}
                          >
                            Alias
                          </Typography>
                        </Grid>
                        <Grid item lg={10} md={9} sm={9} xs={12}>
                          <Input
                            autoComplete="off"
                            type="text"
                            name="alias"
                            id="alias"
                            value={item.alias}
                          />
                        </Grid>
                      </>
                    )}

                    {item.status !== "OPENING ACCOUNT" &&
                    item.status !== "ACTIVE" ? null : (
                      <>
                        <Grid item lg={2} md={3} sm={3} xs={12}>
                          <Typography
                            component="span"
                            variant="subtitle1"
                            style={{
                              float: "left",
                              marginTop: 6,
                              textTransform: "capitalize",
                            }}
                          >
                            Password
                          </Typography>
                        </Grid>
                        <Grid item lg={10} md={9} sm={9} xs={12}>
                          <InputGroup>
                            <Input
                              autoComplete="off"
                              type={
                                this.state.showPassword ? "text" : "password"
                              }
                              name="password"
                              id="password"
                              value={item.password_initial_decrypt}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText>
                                <span onClick={this.handleTogglePassword}>
                                  {this.state.showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </span>
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </Grid>
                      </>
                    )}

                    {item.status !== "OPENING ACCOUNT" &&
                    item.status !== "ACTIVE" ? null : (
                      <>
                        <Grid item lg={2} md={3} sm={3} xs={12}>
                          <Typography
                            component="span"
                            variant="subtitle1"
                            style={{
                              float: "left",
                              marginTop: 6,
                              textTransform: "capitalize",
                            }}
                          >
                            Type
                          </Typography>
                        </Grid>
                        <Grid item lg={10} md={9} sm={9} xs={12}>
                          <Input
                            autoComplete="off"
                            type="text"
                            name="account_type"
                            id="account_type"
                            value={item.account_type}
                          />
                        </Grid>
                      </>
                    )}

                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Lot
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Input
                        autoComplete="off"
                        type="text"
                        name="lot"
                        id="lot"
                        value={item.lot}
                      />
                    </Grid>

                    {item.status !== "OPENING ACCOUNT" ? null : (
                      <>
                        <Grid item lg={2} md={3} sm={3} xs={12}>
                          <Typography
                            component="span"
                            variant="subtitle1"
                            style={{
                              float: "left",
                              marginTop: 6,
                              textTransform: "capitalize",
                            }}
                          >
                            Capital
                          </Typography>
                        </Grid>
                        <Grid item lg={10} md={9} sm={9} xs={12}>
                          <Input
                            autoComplete="off"
                            type="text"
                            name="capital"
                            id="capital"
                            value={item.capital}
                          />
                        </Grid>
                      </>
                    )}

                    <Grid item lg={2} md={3} sm={3} xs={12}>
                      <Typography
                        component="span"
                        variant="subtitle1"
                        style={{
                          float: "left",
                          marginTop: 6,
                          textTransform: "capitalize",
                        }}
                      >
                        Note
                      </Typography>
                    </Grid>
                    <Grid item lg={10} md={9} sm={9} xs={12}>
                      <Input
                        autoComplete="off"
                        type="text"
                        name="note"
                        id="note"
                        value={item.note}
                      />
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button
                  disabled={this.state.submitLoading}
                  variant="contained"
                  size="large"
                  style={{
                    backgroundColor: "#004dcf",
                  }}
                  startIcon={<CheckBox />}
                  onClick={() => this.doProcessedApproved()}
                >
                  {this.state.submitLoading === true ? (
                    <CircularProgress style={{ color: "#fff" }} size={24} />
                  ) : (
                    <Typography
                      variant="button"
                      style={{
                        color: "#fff",
                        textTransform: "capitalize",
                      }}
                    >
                      Approve
                    </Typography>
                  )}
                </Button>
                &nbsp;&nbsp;
                <Button
                  variant="contained"
                  size="large"
                  style={{
                    backgroundColor: "#d0021b",
                  }}
                  startIcon={<Cancel />}
                  onClick={() => this.doProcessedReject()}
                >
                  <Typography
                    variant="button"
                    style={{
                      color: "#fff",
                      textTransform: "capitalize",
                    }}
                  >
                    Reject
                  </Typography>
                </Button>
              </DialogActions>
            </>
          )}
        </Dialog>
      );
    }
  };

  handleNoteChange = () => {
    const noteValue = this.noteInputRef.current.value;
    this.setState({ note: noteValue });
  };

  pressReset = () => {
    this.setState({
      openSuccess: false,
      openSuccessText: "",
      note: "",
    });
    this.doLoadData();
    this.doLoadOption();
    // apiCountJobList()
    //   .then((res) => {
    //     const data = res.data;
    //     if (data.status === "OK") {
    //       const count = data.count;
    //       localStorage.setItem("count", JSON.stringify(count));
    //     }
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //   });
  };

  toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  renderApproveItemInfo = () => {
    let item = this.state.itemSelectedRow;
    let Category = item && item.status ? this.toTitleCase(item.status) : "";
    return (
      <Dialog
        open={this.state.openAlertApprove}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography
              component="span"
              variant="h2"
              style={stylesDialog.title}
            >
              Approve {Category}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseItemInfo()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent style={{ marginTop: 10 }}>
          <DialogContentText id="alert-dialog-description">
            <Typography
              component="span"
              variant="body2"
              style={(stylesListDialog.inline, { fontSize: 16, color: "#333" })}
            >
              Are you sure want to approve account {item.account_id}?
            </Typography>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="note"
            label="Note"
            type="text"
            fullWidth
            value={this.state.note}
            inputRef={this.noteInputRef}
            onChange={this.handleNoteChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.showLoadingApprove}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#808080",
            }}
            startIcon={<Cancel />}
            onClick={this.handleCloseItemInfo}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>{" "}
          <Button
            disabled={this.state.showLoadingApprove}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#0693e3",
            }}
            startIcon={
              this.state.showLoadingApprove === true ? null : <Check />
            }
            onClick={() => this.doApproveItem(item)}
          >
            {this.state.showLoadingApprove === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Yes
              </Typography>
            )}
          </Button>{" "}
        </DialogActions>
      </Dialog>
    );
  };

  renderRejectItemInfo = () => {
    let item = this.state.itemSelectedRow;
    let Category = item && item.status ? this.toTitleCase(item.status) : "";
    return (
      <Dialog
        open={this.state.openAlertReject}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography
              component="span"
              variant="h2"
              style={stylesDialog.title}
            >
              Reject {Category}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseItemInfo()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent style={{ marginTop: 10 }}>
          <DialogContentText id="alert-dialog-description">
            <Typography
              component="span"
              variant="body2"
              style={(stylesListDialog.inline, { fontSize: 16, color: "#333" })}
            >
              Are you sure want to reject account {item.account_id}?
            </Typography>
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="note"
            label="Note"
            type="text"
            fullWidth
            value={this.state.note}
            inputRef={this.noteInputRef}
            onChange={this.handleNoteChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={this.state.showLoadingReject}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#808080",
            }}
            startIcon={<Cancel />}
            onClick={this.handleCloseItemInfo}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>{" "}
          <Button
            disabled={this.state.showLoadingReject}
            variant="contained"
            size="small"
            style={{
              backgroundColor: "#0693e3",
            }}
            startIcon={this.state.showLoadingReject === true ? null : <Check />}
            onClick={() => this.doRejectItem(item)}
          >
            {this.state.showLoadingReject === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Yes
              </Typography>
            )}
          </Button>{" "}
        </DialogActions>
      </Dialog>
    );
  };

  handleCloseValidationAlert = () => {
    this.setState({
      openValidation: false,
      titleValidation: "",
      titleBody: "",
    });
  };

  renderValidationAlert = () => {
    return (
      <Dialog
        open={this.state.openValidation}
        onClose={this.handleCloseValidationAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="label-title-alert">{this.state.titleValidation}</div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <div className="title-body-alert"> {this.state.titleBody} </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <IconButton
            style={{ backgroundColor: "#f2f2f2" }}
            onClick={this.handleCloseValidationAlert}
          >
            <Close />
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  };

  closeStackSuccess = () => {
    this.setState({
      openSuccess: false,
      openSuccessText: "",
      note: "",
    });
  };

  renderSuccess = () => {
    if (this.state.openSuccess === true) {
      setTimeout(() => this.pressReset(), 2000);

      return (
        <div style={{ margin: 10 }}>
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton aria-label="close" color="inherit" size="small">
                  <Close fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {this.state.openSuccessText}
            </Alert>
          </Stack>
        </div>
      );
    }
  };

  handleCloseAddNew = () => {
    const clearField = (ref) => {
      if (ref && ref.current) ref.current = null;
    };

    [
      this.setAccountNumber,
      this.setEmail,
      this.setAlias,
      this.setPassword,
      this.setLot,
      this.setCapital,
      this.setNote,
      this.setAccountType,
    ].forEach(clearField);

    this.setAgent.current = [];
    this.setUser.current = [];

    this.setCategory.current = {
      value: "OPENING ACCOUNT",
      label: "OPENING ACCOUNT",
    };

    this.setState({
      selectedAccount: null,
      selectedAccountType: null,
      selectedAgent: null,
      selectedUser: null,
      optionAccount: [],
      originalDataAccounts: [],
      lotError: null,
      isLoginSuccessful: false,
      isAffiliated: null,
      loadingAffiliation: false,
      isCustomEmail: false,
      selectedEmail: null,
      setOpenAddNew: false,
      showPassword: false,
    });

    this.forceUpdate();
  };

  pressAddNew = () => {
    this.setState({
      setOpenAddNew: true,
      isLoginSuccessful: false,
      showPassword: false,
      lotError: null,
    });
  };

  handleChangeCategory = (category) => {
    this.setCategory.current = category;
    // const newCategory = category ? category.value : "";

    // const clearField = (ref) => {
    //   if (ref && ref.current) ref.current = null;
    // };

    // [
    //   this.setAccountNumber,
    //   this.setEmail,
    //   this.setAlias,
    //   this.setPassword,
    //   // this.setLot,
    //   this.setCapital,
    //   this.setNote,
    //   this.setAccountType,
    // ].forEach(clearField);

    this.setAgent.current = [];
    this.setUser.current = [];

    this.setState({
      selectedAccount: null,
      selectedAccountType: null,
      selectedAgent: null,
      selectedUser: null,
      optionAccount: [],
      originalDataAccounts: [],
      lotError: null,
      isLoginSuccessful: false,
      isAffiliated: null,
      loadingAffiliation: false,
      isCustomEmail: false,
      selectedEmail: null,
      showPassword: false,
    });

    this.forceUpdate();
  };

  handleChangeAgent = (agent) => {
    this.setAgent.current = agent;
    this.forceUpdate();
  };

  handleChangeMaster = (master) => {
    this.setMaster.current = master;
    this.forceUpdate();
  };

  handleChangeAccountType = (accountType) => {
    this.setAccountType.current = accountType;
    this.forceUpdate();
  };

  handleChangeUser = (user) => {
    this.setUser.current = user;
    this.forceUpdate();
  };

  handleChangeAccount = (account) => {
    this.setAccountNumber.current = account;
    this.forceUpdate();
  };

  handleChangeEmail = (val) => {
    // console.log("value email: ", val);

    if (this.setAccountNumber && this.setAccountNumber.current) {
      this.setAccountNumber.current.value = "";
    }

    if (val.value === "custom_email") {
      this.setState({
        isCustomEmail: true,
        selectedEmail: val,
        selectedAccount: null,
        optionAccount: [],
        isAffiliated: null,
      });

      if (this.setEmail && this.setEmail.current) {
        this.setEmail.current.value = "";
      }
    } else {
      this.setState({
        isCustomEmail: false,
        selectedEmail: val,
        selectedAccount: null,
        optionAccount: [],
        isAffiliated: null,
      });

      this.setEmail.current = val;

      const matchedEmail = this.state.emailBrokerDataRecords.find(
        (obj) => obj.email === val.value,
      );

      // console.log("matchedEmail =>", matchedEmail);

      if (matchedEmail && Array.isArray(matchedEmail.new_accounts)) {
        const optionAccount = matchedEmail.new_accounts.map((acc) => ({
          label: `${acc.account_number} - ${acc.server} ${acc.account_type}`,
          value: acc.account_number,
        }));

        this.setState({
          optionAccount: optionAccount,
          originalDataAccounts: matchedEmail.accounts,
        });

        // console.log("optionAccount =>", optionAccount);
      } else {
        this.setState({
          optionAccount: [],
          originalDataAccounts: [],
        });
      }
    }
    this.forceUpdate();
  };

  handleCheckAffiliation = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const email = (this.setEmail.current && this.setEmail.current.value) || "";

    // console.log("this.setEmail.current: ", this.setEmail.current);

    if (!email) {
      this.setState({
        openValidation: true,
        titleValidation: "Email is required",
        titleBody: "Please enter your email address to proceed.",
      });
      return;
    }

    if (!emailRegex.test(email)) {
      this.setState({
        openValidation: true,
        titleValidation: "Invalid Email",
        titleBody:
          "The email address format is invalid. Please check and try again.",
      });
      return;
    }

    this.setState({ loadingAffiliation: true, isAffiliated: null });

    const params = { email };
    apiCheckEmailAffiliation(params)
      .then((res) => {
        const data = res.data;

        // const availableAccount = this.state.accountAutoOption;

        // const existing = new Set(availableAccount.map((r) => r.value));

        if (data.affiliation === false || !data.accounts.length) {
          this.setState({
            openValidation: true,
            titleValidation: "Not Affiliated",
            titleBody: "This email address is not affiliated with any account.",
            isAffiliated: false,
            loadingAffiliation: false,
            optionAccount: [],
            originalDataAccounts: [],
          });
        } else {
          // const optionAccount = data.accounts.map((acc) => ({
          //   label: acc,
          //   value: acc,
          // }));

          const accounts = data.accounts;
          const existingAccount = data.existing_accounts;
          const newAccount = data.new_accounts;

          const optionAccount = newAccount.map((acc) => ({
            label: `${acc.account_number} - ${acc.server} ${acc.account_type}`,
            value: acc.account_number,
          }));

          const originalDataAccounts = accounts.map(
            (acc) => acc.account_number,
          );
          // console.log("originalDataAccounts: ", originalDataAccounts);
          // const optionAccount = data.accounts
          //   .filter((acc) => !existing.has(acc))
          //   .map((acc) => ({
          //     value: acc,
          //     label: acc,
          //   }));

          const total = accounts.length;
          const newCount = newAccount.length;
          const existingCount = existingAccount.length;

          this.setState({
            openValidation: true,
            titleValidation: "Affiliated",
            titleBody: `${total} affiliated account(s) (including ${existingCount} existing and ${newCount} new).`,
            isAffiliated: true,
            optionAccount,
            originalDataAccounts,
            loadingAffiliation: false,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          openValidation: true,
          titleValidation: "Affiliation Check Failed",
          titleBody: "Something went wrong while checking affiliation.",
          isAffiliated: false,
          loadingAffiliation: false,
        });
      });
  };

  validateLot = (value) => {
    const lot = parseFloat(value);
    const type =
      (this.setAccountType.current && this.setAccountType.current.value) || "";

    const category =
      (this.setCategory.current && this.setCategory.current.value) || "";

    if (!/^\d+(\.\d+)?$/.test(value)) {
      this.setState({
        lotError: "Lot format must be numbers with dot (.) only.",
      });
      return false;
    }

    const typeLabel =
      type === "HR_EU"
        ? "HR SPDR XAU"
        : type === "LR_XAU"
          ? "Low Risk XAU"
          : type === "SPDR_XAU"
            ? "SPDR XAU"
            : type === "EURUSDc"
              ? "EURUSDc"
              : type === "EURUSD_2"
                ? "EURUSD 2.0"
                : type === "EURUSD_3"
                  ? "EURUSD 3.0"
                  : type === "SM"
                    ? "SM"
                    : type === "JKW_XAU"
                      ? "JKW XAU"
                      : type === "JKW_24HR_XAU"
                        ? "JKW 24HR XAU"
                        : type === "CTC"
                          ? "CTC"
                          : type === "FTG"
                            ? "FTG"
                            : type === "OSOK"
                              ? "OSOK"
                              : type === "BTC"
                                ? "BTC"
                                : type === "BlueStar"
                                  ? "BlueStar"
                                  : type === "BTCMu"
                                    ? "BTCMu"
                                    : type === "BlueStar5R"
                                      ? "BlueStar5R"
                                      : type === "GBPJPY"
                                        ? "GBPJPY"
                                        : type === "JKW_3_XAU"
                                          ? "JKW 3.0 XAU"
                                          : type === "JKW_3_SLOW_XAU"
                                            ? "JKW 3.0 SLOW"
                                            : type === "JKW24K"
                                              ? "JKW24K"
                                              : type === "BlueStar15"
                                                ? "BlueStar15"
                                                : type === "BlueStar15R"
                                                  ? "BlueStar15R"
                                                  : type === "BlueStarR"
                                                    ? "BlueStarR"
                                                    : type === "RJW88Slow"
                                                      ? "RJW88Slow"
                                                      : type === "RJW88Fast"
                                                        ? "RJW88Fast"
                                                        : type === "JKW88"
                                                          ? "JKW88"
                                                          : type === "BlueStar5"
                                                            ? "BlueStar5"
                                                            : type ===
                                                                "JKWRJWFAST"
                                                              ? "JKWRJWFast"
                                                              : type ===
                                                                "XAUUSDc";

    // console.log("type: ", type);

    if (type === "EURUSDc" || type === "EURUSD_2") {
      if (lot < 1 || lot > 10) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 10`,
        });
        return false;
      }
    } else if (type === "EURUSD_3") {
      if (lot < 1 || lot > 500) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 500`,
        });
        return false;
      }
    } else if (type === "HR_EU") {
      if (lot < 1 || lot > 13) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 13`,
        });
        return false;
      }
    } else if (type === "XAUUSDc") {
      if (lot < 1 || lot > 3) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 3`,
        });
        return false;
      }
    } else if (type === "LR_XAU") {
      if (lot < 1 || lot > 7) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 7`,
        });
        return false;
      }
    } else if (type === "SPDR_XAU") {
      if (lot < 1 || lot > 13) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 13`,
        });
        return false;
      }
    } else if (type === "JKW_XAU" || type === "JKW_24HR_XAU") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "SM") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "CTC") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "FTG") {
      if (lot < 1 || lot > 500) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 500`,
        });
        return false;
      }
    } else if (type === "OSOK") {
      if (lot < 1 || lot > 500) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 500`,
        });
        return false;
      }
    } else if (type === "JKW_3_XAU") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "JKW_3_SLOW_XAU") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "JKW24K") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "BlueStar15") {
      if (lot < 1 || lot > 500) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 500`,
        });
        return false;
      }
    } else if (type === "JKWRJWFAST") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "BlueStar15R") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "BlueStar5R") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "BlueStarR") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "RJW88Slow") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "RJW88Fast") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "JKW88") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "BlueStar5") {
      if (lot < 1 || lot > 500) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 500`,
        });
        return false;
      }
    } else if (type === "GBPJPY") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 100`,
        });
        return false;
      }
    } else if (type === "BTC" || type === "BlueStar" || type === "BTCMu") {
      if (lot < 1 || lot > 10) {
        this.setState({
          lotError: `Lot for ${typeLabel} must be between 1 and 10`,
        });
        return false;
      }
    } else if (category === "CHANGE LOT") {
      if (lot < 1 || lot > 100) {
        this.setState({
          lotError: "Lot must be between 1 and 100 for CHANGE LOT.",
        });
        return false;
      }
    } else {
      this.setState({
        lotError: "Invalid account type for lot configuration.",
      });
      return false;
    }

    this.setState({ lotError: null });
    return true;
  };

  generateRandomHex = (length) => {
    return [...Array(length)]
      .map(() => Math.floor(Math.random() * 16).toString(16))
      .join("");
  };

  // generateTradingPassword(type = "master") {
  //   const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  //   const lowercase = "abcdefghijklmnopqrstuvwxyz";
  //   const numbers = "0123456789";

  //   const minLength = 8;
  //   const maxLength = 15;

  //   const allChars = uppercase + lowercase + numbers;

  //   let password = "";

  //   password += uppercase[Math.floor(Math.random() * uppercase.length)];
  //   password += lowercase[Math.floor(Math.random() * lowercase.length)];
  //   password += numbers[Math.floor(Math.random() * numbers.length)];

  //   if (type === "investor") {
  //     password += numbers[Math.floor(Math.random() * numbers.length)];
  //   } else if (type === "master") {
  //     password += uppercase[Math.floor(Math.random() * uppercase.length)];
  //   }

  //   const remainingLength =
  //     Math.floor(Math.random() * (maxLength - minLength + 1)) +
  //     minLength -
  //     password.length;

  //   for (let i = 0; i < remainingLength; i++) {
  //     password += allChars[Math.floor(Math.random() * allChars.length)];
  //   }

  //   password = password
  //     .split("")
  //     .sort(() => Math.random() - 0.5)
  //     .join("");

  //   return password;
  // }

  generateTradingPassword(type = "master") {
    const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowercase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const symbols = "!@#$%^&*()-_=+[]{}|;:,.<>?";

    const minLength = 8;
    const maxLength = 15;

    const allChars = uppercase + lowercase + numbers + symbols;

    let password = "";

    password += uppercase[Math.floor(Math.random() * uppercase.length)];
    password += lowercase[Math.floor(Math.random() * lowercase.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += symbols[Math.floor(Math.random() * symbols.length)];

    if (type === "investor") {
      password += numbers[Math.floor(Math.random() * numbers.length)];
    } else if (type === "master") {
      password += uppercase[Math.floor(Math.random() * uppercase.length)];
    }

    const remainingLength =
      Math.floor(Math.random() * (maxLength - minLength + 1)) +
      minLength -
      password.length;

    for (let i = 0; i < remainingLength; i++) {
      password += allChars[Math.floor(Math.random() * allChars.length)];
    }

    password = password
      .split("")
      .sort(() => Math.random() - 0.5)
      .join("");

    return password;
  }

  checkData = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const category =
      (this.setCategory.current && this.setCategory.current.value) || "";
    const email = (this.setEmail.current && this.setEmail.current.value) || "";

    const accountType =
      (this.setAccountType.current && this.setAccountType.current.value) || "";
    const account_number =
      (this.setAccountNumber.current && this.setAccountNumber.current.value) ||
      "";

    // const account_number_server =
    //   (this.setAccountNumber.current && this.setAccountNumber.current.label) ||
    //   "";

    const platform_server_broker =
      (this.setAccountNumber.current &&
        (this.setAccountNumber.current.server ||
          this.setAccountNumber.current.label)) ||
      "";

    const lot = (this.setLot.current && this.setLot.current.value) || "";

    // console.log("this.setLot.current: ", this.setAccountNumber.current);

    const password =
      (this.setPassword.current && this.setPassword.current.value) || "";
    const capital =
      (this.setCapital.current && this.setCapital.current.value) || 0;
    const alias = (this.setAlias.current && this.setAlias.current.value) || "";
    const agent =
      this.setAgent.current && Array.isArray(this.setAgent.current)
        ? this.setAgent.current
        : this.setAgent.current
          ? [this.setAgent.current]
          : [];

    // const master =
    //   this.setMaster.current && Array.isArray(this.setMaster.current)
    //     ? this.setMaster.current
    //     : this.setMaster.current
    //     ? [this.setMaster.current]
    //     : [];

    const user =
      this.setUser.current && Array.isArray(this.setUser.current)
        ? this.setUser.current
        : this.setUser.current
          ? [this.setUser.current]
          : [];

    const masterPassword = this.generateTradingPassword("master");
    const investorPassword = this.generateTradingPassword("investor");

    // console.log("account_server: ", platform_server_broker);

    const serverName = (platform_server_broker || "").toLowerCase();

    const platform_server = serverName.includes("mt5")
      ? "MT5"
      : serverName.includes("mt4")
        ? "MT4"
        : "UNKNOWN";

    if (category === undefined || category === null || category === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Category is required",
        titleBody: "Please select a valid category.",
      });
    } else if (
      (email === undefined || email === null || email === "") &&
      category === "OPENING ACCOUNT"
    ) {
      this.setState({
        openValidation: true,
        titleValidation: "Email is required",
        titleBody: "Please enter your email address to proceed.",
      });
    } else if (!emailRegex.test(email) && category === "OPENING ACCOUNT") {
      this.setState({
        openValidation: true,
        titleValidation: "Invalid Email",
        titleBody:
          "The email address format is invalid. Please check and try again.",
      });
    } else if (
      account_number === undefined ||
      account_number === null ||
      account_number === ""
    ) {
      this.setState({
        openValidation: true,
        titleValidation: "Account Number Missing",
        titleBody: "Please enter the account number.",
      });
    } else if (
      (category === "OPENING ACCOUNT" || category === "ACTIVE") &&
      accountType === ""
    ) {
      this.setState({
        openValidation: true,
        titleValidation: "Account Type Required",
        titleBody: "Please select the account type.",
      });
    } else if (category === "OPENING ACCOUNT" && alias === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Alias Required",
        titleBody: "Please enter an alias for the account.",
      });
    } else if (category === "OPENING ACCOUNT" && password === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Password Required",
        titleBody: "Please enter a password for the account.",
      });
    } else if (category === "OPENING ACCOUNT" && lot === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Lot Size Required",
        titleBody: "Please enter the lot size.",
      });
    } else if (category === "CHANGE LOT" && lot === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Lot Size Required",
        titleBody: "Please enter the lot size.",
      });
    } else if (category === "ACTIVE" && lot === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Lot Size Required",
        titleBody: "Please enter the lot size.",
      });
    } else if (category === "ACTIVE" && platform_server === "UNKNOWN") {
      this.setState({
        openValidation: true,
        titleValidation: "Platform Not Supported",
        titleBody: "The selected platform is not supported.",
      });
    } else if (
      (category === "OPENING ACCOUNT" ||
        category === "ACTIVE" ||
        category === "CHANGE LOT") &&
      this.state.lotError !== null
    ) {
      this.setState({
        openValidation: true,
        titleValidation: "Please Check the Lot Size",
        titleBody: this.state.lotError,
      });
    }
    // else if (serverName.includes("mt5") && category === "OPENING ACCOUNT") {
    //   this.setState({
    //     openValidation: true,
    //     titleValidation: "Account Not Supported",
    //     titleBody:
    //       "We're sorry, but MT5 accounts are currently not supported for this request. Please try using a different account number.",
    //   });
    // }
    else {
      const accounts = this.state.originalDataAccounts;

      const paramsOpening = {
        category: category,
        subCategory: "",
        ticket_id: this.generateRandomHex(16),
        secretKey: this.state.secretKey,
        data: {
          account_id: account_number,
          accountType: accountType,
          alias: alias,
          lot: lot,
          password: password,
          password_master: masterPassword,
          password_investor: investorPassword,
          capital: capital,
          note: "",
          agent: agent,
          user: user,
          client_id: this.state.loginInfo.phoneno,
          executor: this.state.loginInfo.name,
          email_broker: email,
          affiliation_account: accounts,
          platform: platform_server,
        },
      };

      const paramsChangeLot = {
        category: "ACCOUNT ADJUSTMENT",
        subCategory: category,
        ticket_id: this.generateRandomHex(16),
        secretKey: this.state.secretKey,
        data: {
          account_id: account_number,
          lot: lot,
          note: "",
          executor: this.state.loginInfo.name,
          client_id: this.state.loginInfo.phoneno,
        },
      };

      const paramsSuspend = {
        category: category,
        subCategory: "",
        ticket_id: this.generateRandomHex(16),
        secretKey: this.state.secretKey,
        data: {
          account_id: account_number,
          client_id: this.state.loginInfo.phoneno,
          executor: this.state.loginInfo.name,
        },
      };

      const paramsActive = {
        category: category,
        subCategory: "",
        ticket_id: this.generateRandomHex(16),
        secretKey: this.state.secretKey,
        data: {
          account_id: account_number,
          accountType: accountType,
          lot: lot,
          password: password,
          password_master: masterPassword,
          password_investor: investorPassword,
          client_id: this.state.loginInfo.phoneno,
          executor: this.state.loginInfo.name,
          platform: platform_server,
        },
      };

      const setupParamsCategory =
        category === "OPENING ACCOUNT"
          ? paramsOpening
          : category === "CHANGE LOT"
            ? paramsChangeLot
            : category === "SUSPEND"
              ? paramsSuspend
              : category === "ACTIVE"
                ? paramsActive
                : {};

      if (
        category === "CHANGE LOT" ||
        category === "SUSPEND" ||
        category === "ACTIVE" ||
        category === "OPENING ACCOUNT"
      ) {
        const paramsChangeLot = {
          category: "ACCOUNT ADJUSTMENT",
          subCategory: category,
          ticket_id: this.generateRandomHex(16),
          secretKey: this.state.secretKey,
          data: {
            account_id: account_number,
            lot: lot,
            note: `up lot size ${lot}`,
            executor: this.state.loginInfo.name,
            client_id: this.state.loginInfo.phoneno,
          },
        };

        const setupParamsByCategory =
          category === "CHANGE LOT"
            ? paramsChangeLot
            : category === "SUSPEND"
              ? paramsSuspend
              : category === "ACTIVE"
                ? paramsActive
                : paramsOpening;

        console.info("setupParamsByCategory: ", setupParamsByCategory);

        this.setState({
          submitLoading: true,
        });
        apiAutoActionSubmissionApprove(setupParamsByCategory)
          .then((res) => {
            this.setState({
              submitLoading: false,
            });
            const data = res.data;
            if (data.code === 200) {
              this.setState({
                openSuccess: true,
                openSuccessText:
                  "The ticket has been added and auto-approved successfully.",
                setOpenAddNew: false,
              });
            }
          })
          .catch((err) => {
            this.setState({
              submitLoading: false,
            });
            console.error(err);
          });
      } else {
        console.info("setupParamsCategory: ", setupParamsCategory);
        this.setState({
          submitLoading: true,
        });
        apiAutoActionSubmission(setupParamsCategory)
          .then((res) => {
            this.setState({
              submitLoading: false,
            });
            const data = res.data;
            if (data.code === 200) {
              this.setState({
                openSuccess: true,
                openSuccessText: "The ticket has been successfully added.",
                setOpenAddNew: false,
              });
            }
          })
          .catch((err) => {
            this.setState({
              submitLoading: false,
            });
            console.error(err);
          });
      }
    }
  };

  handleTogglePassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  renderDialogAddAccount = () => {
    const isDisabled =
      this.setCategory.current.value === "OPENING ACCOUNT" &&
      this.state.optionAccount.length === 0 &&
      (this.state.isAffiliated === false || this.state.isAffiliated === null);

    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={this.state.setOpenAddNew}
        // fullWidth={true}
        // maxWidth="md"
        fullScreen={true}
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography variant="h5" style={stylesDialog.title}>
              Add Ticket
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseAddNew()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent dividers>
          <Box sx={{ flexGrow: 1 }} style={{ marginBottom: 60, marginTop: 20 }}>
            <Grid container spacing={2}>
              <Grid item lg={3} md={3} xs={12} sm={12}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  Category
                </Typography>
              </Grid>
              <Grid item lg={9} md={9} xs={12} sm={12}>
                <Select
                  classNamePrefix="select"
                  placeholder="Select a category"
                  onChange={this.handleChangeCategory}
                  options={this.state.categoryOption}
                  value={this.setCategory.current}
                  styles={{
                    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                  menuPlacement="bottom"
                />
              </Grid>

              {this.setCategory.current.value === "OPENING ACCOUNT" && (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Email
                    </Typography>
                  </Grid>

                  <Grid item lg={6} md={6} xs={12} sm={12}>
                    {this.state.optionEmailBrokerUser.length > 0 &&
                    !this.state.isCustomEmail ? (
                      <>
                        <Select
                          classNamePrefix="select"
                          placeholder="Select or input new email"
                          value={this.state.selectedEmail}
                          onChange={this.handleChangeEmail}
                          options={this.state.optionEmailBrokerUser}
                          styles={{
                            menuPortal: (provided) => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          menuPlacement="bottom"
                        />
                      </>
                    ) : (
                      <Input
                        autoComplete="off"
                        type="email"
                        name="email"
                        id="email"
                        innerRef={this.setEmail}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    lg={3}
                    md={3}
                    xs={12}
                    sm={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleCheckAffiliation}
                      disabled={this.state.loadingAffiliation}
                    >
                      {this.state.loadingAffiliation ? (
                        <CircularProgress size={20} style={{ color: "#fff" }} />
                      ) : (
                        "Check Affiliation"
                      )}
                    </Button>
                  </Grid>
                  {this.state.isAffiliated !== null && (
                    <>
                      <Grid
                        item
                        lg={3}
                        md={3}
                        xs={12}
                        sm={12}
                        style={{ marginTop: -8 }}
                      ></Grid>
                      <Grid
                        item
                        lg={9}
                        md={9}
                        xs={12}
                        sm={12}
                        style={{ marginTop: -8 }}
                      >
                        <Typography
                          variant="caption"
                          style={{
                            color: this.state.isAffiliated ? "green" : "red",
                            fontWeight: "bold",
                            fontSize: "0.75rem",
                            display: "block",
                            marginTop: 4,
                          }}
                        >
                          {this.state.isAffiliated
                            ? "✅ This email is affiliated."
                            : "❌ This email is not affiliated."}
                        </Typography>
                      </Grid>
                    </>
                  )}
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" ? (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Account Number
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    <Select
                      classNamePrefix="select"
                      placeholder="Select a account"
                      // onChange={this.handleChangeAccount}
                      value={this.state.selectedAccount}
                      onChange={(val) => {
                        this.setState({ selectedAccount: val });
                        this.handleChangeAccount(val);
                      }}
                      options={this.state.accountAutoOption}
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      // menuPosition={"fixed"}
                      menuPosition={isIOS() ? "absolute" : "fixed"}
                      menuPlacement="bottom"
                    />
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Account Number
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    {/* <Select
                      classNamePrefix="select"
                      placeholder="Select a account"
                      // onChange={this.handleChangeAccount}
                      value={this.state.selectedAccount}
                      onChange={(val) => {
                        this.setState({ selectedAccount: val });
                        this.handleChangeAccount(val);
                      }}
                      options={this.state.optionAccount}
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition={"fixed"}
                      menuPlacement="bottom"
                      isDisabled={isDisabled}
                    /> */}
                    <Select
                      classNamePrefix="select"
                      placeholder="Select an account"
                      value={this.state.selectedAccount}
                      onChange={(val) => {
                        this.setState({ selectedAccount: val });
                        this.handleChangeAccount(val);
                      }}
                      options={this.state.optionAccount}
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      menuPortalTarget={isIOS() ? undefined : document.body}
                      menuPosition={isIOS() ? "absolute" : "fixed"}
                      menuPlacement="bottom"
                      isDisabled={isDisabled}
                    />
                  </Grid>
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" &&
              this.setCategory.current.value !== "ACTIVE" ? null : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Type
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    <Select
                      classNamePrefix="select"
                      placeholder="Select a type"
                      isClearable={true}
                      // onChange={this.handleChangeAccountType}
                      value={this.state.selectedAccountType}
                      onChange={(val) => {
                        this.setState({ selectedAccountType: val });
                        this.handleChangeAccountType(val);
                      }}
                      options={this.state.optionAccountType}
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition={"fixed"}
                      menuPlacement="bottom"
                      isDisabled={isDisabled}
                    />
                  </Grid>
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" ? null : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Alias
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="capital"
                      id="capital"
                      innerRef={this.setAlias}
                      disabled={isDisabled}
                    />
                  </Grid>
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" &&
              this.setCategory.current.value !== "ACTIVE" ? null : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Password
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} xs={12} sm={12}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <InputGroup style={{ flex: 1 }}>
                        <Input
                          autoComplete="off"
                          type={this.state.showPassword ? "text" : "password"}
                          name="password"
                          id="password"
                          innerRef={this.setPassword}
                          disabled={isDisabled}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>
                            <span onClick={this.handleTogglePassword}>
                              {this.state.showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </span>
                          </InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    lg={3}
                    md={3}
                    xs={12}
                    sm={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    {this.state.isLoginSuccessful ? (
                      <Button
                        variant="contained"
                        style={{ backgroundColor: "#4caf50" }}
                        disabled
                      >
                        <Check style={{ color: "#fff" }} />
                      </Button>
                    ) : (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleCheckActivation}
                      >
                        Check Password
                      </Button>
                    )}
                  </Grid>
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" &&
              this.setCategory.current.value !== "CHANGE LOT" &&
              this.setCategory.current.value !== "ACTIVE" ? null : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Lot
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="lot"
                      id="lot"
                      innerRef={this.setLot}
                      onBlur={(e) => this.validateLot(e.target.value)}
                      disabled={isDisabled}
                    />
                    {this.state.lotError && (
                      <Typography variant="caption" color="error">
                        {this.state.lotError}
                      </Typography>
                    )}
                  </Grid>
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" ? null : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      Agent
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    <Select
                      classNamePrefix="select"
                      placeholder="Select a agent"
                      isClearable={true}
                      // onChange={this.handleChangeAgent}
                      value={this.state.selectedAgent}
                      onChange={(val) => {
                        this.setState({ selectedAgent: val });
                        this.handleChangeAgent(val);
                      }}
                      options={this.state.optionAgent}
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition={"fixed"}
                      menuPlacement="top"
                      isDisabled={isDisabled}
                    />
                  </Grid>
                </>
              )}

              {this.setCategory.current.value !== "OPENING ACCOUNT" ? null : (
                <>
                  <Grid item lg={3} md={3} xs={12} sm={12}>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      style={{
                        float: "left",
                        marginTop: 6,
                        textTransform: "capitalize",
                      }}
                    >
                      User
                    </Typography>
                  </Grid>
                  <Grid item lg={9} md={9} xs={12} sm={12}>
                    <Select
                      classNamePrefix="select"
                      placeholder="Select a user"
                      isClearable={true}
                      // onChange={this.handleChangeUser}
                      value={this.state.selectedUser}
                      onChange={(val) => {
                        this.setState({ selectedUser: val });
                        this.handleChangeUser(val);
                      }}
                      options={this.state.optionUser}
                      styles={{
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition={"fixed"}
                      menuPlacement="top"
                      isDisabled={isDisabled}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#d0021b",
            }}
            startIcon={<Cancel />}
            onClick={() => this.handleCloseAddNew()}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>
          &nbsp;&nbsp;
          <Button
            disabled={this.state.submitLoading}
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#004dcf",
            }}
            startIcon={<Save />}
            onClick={() => this.checkData()}
          >
            {this.state.submitLoading === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Save
              </Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const account_number =
      (this.setAccountNumber.current && this.setAccountNumber.current.value) ||
      "";
    const modalStatus =
      this.state.openModalLoading &&
      (!this.state.messagesClientGUI || !this.state.messagesClientGUI.status)
        ? "Please Wait"
        : this.state.messagesClientGUI && this.state.messagesClientGUI.status;
    const modalMessage =
      this.state.openModalLoading &&
      (!this.state.messagesClientGUI || !this.state.messagesClientGUI.message)
        ? "Request Check Password"
        : this.state.messagesClientGUI && this.state.messagesClientGUI.message;
    const modalReference =
      this.state.openModalLoading &&
      (!this.state.messagesClientGUI ||
        !this.state.messagesClientGUI.referenceId)
        ? account_number
        : this.state.messagesClientGUI &&
          this.state.messagesClientGUI.referenceId;

    return (
      <Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper
                style={{
                  borderLeft: 6,
                  borderColor: "#2f55a2",
                  color: "#FFF",
                  maxHeight: 100,
                  padding: 16,
                  paddingBottom: 24,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography
                      component="span"
                      variant="h1"
                      style={
                        (stylesListComent.inline,
                        {
                          fontSize: 20,
                          color: "#000",
                          fontWeight: "bold",
                        })
                      }
                    >
                      Job List Incoming
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="contentDate">
                      <div style={{ marginRight: 16 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#008b02",
                          }}
                          startIcon={<AddBox />}
                          onClick={() => this.pressAddNew()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Add Ticket
                          </Typography>
                        </Button>
                      </div>
                      <div style={{ marginRight: 0 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#1273DE",
                          }}
                          startIcon={<Refresh />}
                          onClick={() => this.pressReset()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Refresh
                          </Typography>
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>

        {this.renderSuccess()}
        <br></br>
        <div className="box-container">
          <ReactTable
            ref={(r) => (this.reactTable = r)}
            data={this.state.tableData}
            columns={this.tableColumns}
            style={{ backgroundColor: "#f2f2f2" }}
            filterable
            defaultFilterMethod={defaultFilterMethod}
            defaultPageSize={500}
            showPageJump={false}
            showPageSizeOptions={false}
            showPagination={false}
          />
        </div>
        {this.renderValidationAlert()}
        {this.renderOpenDetail()}
        {this.renderDialogAddAccount()}
        <ModalLoading
          open={this.state.openModalLoading}
          status={modalStatus}
          message={modalMessage}
          referenceId={modalReference}
          onClose={() =>
            this.setState({
              openModalLoading: false,
              messagesClientGUI: null,
            })
          }
        />
      </Box>
    );
  }
}
export default SubmissionFormListPage;
